export const TOURNAMENT_STATUSES = {
  ACTIVE: 'active',
  UPCOMING: 'upcoming',
  FINISHED: 'finished',
} as const;

export type TournamentStatus = typeof TOURNAMENT_STATUSES[keyof typeof TOURNAMENT_STATUSES];

// Sort options for the tournament list endpoints
export const TOURNAMENT_LIST_SORTS = {
  CREATED_DESC: 'created_desc',
  CREATED_ASC: 'created_asc',
  START_ASC: 'start_asc',
  NAME_ASC: 'name_asc',
  STATUS_ASC: 'status_asc',
} as const;

export type TournamentListSort = typeof TOURNAMENT_LIST_SORTS[keyof typeof TOURNAMENT_LIST_SORTS];
